import { assignSafe, cloneDeep, SEnumType } from '@summit/core';
import { GridsterItem } from 'angular-gridster2';

export class SDashboardItem<T extends SEnumType> {
  constructor(jsonData?: Partial<SDashboardItem<T>>) {
    assignSafe(this, cloneDeep(jsonData)); //need to clone for sub items
  }
  //EBO
  item: T;
  title?: string;

  gridData: GridsterItem;
  //GridsterItem
  // x: number; //col
  // y: number; //row
  // rows: number; //span
  // cols: number; //span
  // layerIndex?: number;
  // initCallback?: (item: GridsterItem, itemComponent: GridsterItemComponentInterface) => void;
  // dragEnabled?: boolean;
  // resizeEnabled?: boolean;
  // resizableHandles?: {
  //   s?: boolean;
  //   e?: boolean;
  //   n?: boolean;
  //   w?: boolean;
  //   se?: boolean;
  //   ne?: boolean;
  //   sw?: boolean;
  //   nw?: boolean;
  // };
  // compactEnabled?: boolean;
  // maxItemRows?: number;
  // minItemRows?: number;
  // maxItemCols?: number;
  // minItemCols?: number;
  // minItemArea?: number;
  // maxItemArea?: number;
}
